export default __webpack_public_path__ + "static/media/f3.46bdab0e.jpeg";